import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'

/**
 * Figma (node 428:1425):
 * Layout: flex gap-2 (8px) items-start
 * Label: text-sm font-medium leading-5 (20px) text-foreground
 * Description: text-sm font-normal leading-5 text-muted-foreground
 * Label+desc gap: gap-0.5 (2px)
 */
export interface IntuiSwitchProps {
  id?: string
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  label?: string
  description?: string
  className?: string
}

function IntuiSwitch({ id, checked, onCheckedChange, disabled, label, description, className }: IntuiSwitchProps) {
  const switchId = id ?? `intui-switch-${Math.random().toString(36).slice(2, 9)}`
  return (
    <div className={cn('flex items-start gap-2', className)}>
      <Switch id={switchId} checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
      {(label || description) && (
        <div className="flex flex-1 flex-col gap-0.5">
          {label && <label htmlFor={switchId} className="text-sm font-medium leading-5 text-foreground">{label}</label>}
          {description && <p className="text-sm leading-5 text-muted-foreground">{description}</p>}
        </div>
      )}
    </div>
  )
}

export { IntuiSwitch }
